import { Component, OnInit } from '@angular/core';

import { SettingGroup } from '../../../models/setting-group';

import { AlertService } from '../../../services/common/alert.service';
import { SettingGroupService } from '../../../services/settings/setting-group.service';

declare var swal: any;

@Component({
  selector: 'app-setting-group-index',
  templateUrl: './setting-group-index.component.html',
  styleUrls: ['./setting-group-index.component.css'],
})
export class SettingGroupIndexComponent implements OnInit {
  settingGroups: Array<SettingGroup> = [];
  selectedSettingGroup: SettingGroup;
  addingSettingGroup: boolean = false;
  newSettingGroup: SettingGroup = new SettingGroup();
  editingSettingGroups: any = {};

  constructor(private alertService: AlertService, private settingGroupService: SettingGroupService) {
    this.settingGroupService.getSettingGroups({}).then((response_json) => {
      this.settingGroups = response_json;
    });
  }

  ngOnInit() {}

  onSettingGroupFormEvent(formResult: any, settingGroup: SettingGroup | undefined = undefined) {
    switch (formResult) {
      case 'Form Cancelled':
        if (settingGroup) this.editingSettingGroups[settingGroup.id] = false;
        else {
          this.addingSettingGroup = false;
          this.newSettingGroup = new SettingGroup();
        }
        break;
      case 'Setting Group created':
        this.addingSettingGroup = false;
        this.newSettingGroup = new SettingGroup();
        this.settingGroupService.getSettingGroups({}).then((response_json) => {
          this.settingGroups = response_json;
        });
        break;
      case 'Setting Group updated':
        if (settingGroup) {
          this.editingSettingGroups[settingGroup.id] = false;
          this.settingGroupService.getSettingGroups({}).then((response_json) => {
            this.settingGroups = response_json;
          });
        }
        break;
    }
  }

  deleteSettingGroup(settingGroup: SettingGroup) {
    let scope: SettingGroupIndexComponent = this;
    swal({
      title: 'Delete setting',
      text: `Delete - ${settingGroup.name} ?`,
      icon: 'warning',
      dangerMode: true,
      buttons: {
        cancel: {
          text: 'No',
          value: false,
          visible: true,
          className: '',
          closeModal: true,
        },
        confirm: {
          text: 'Yes',
          value: true,
          visible: true,
          className: '',
          closeModal: true,
        },
      },
    })
      .then((confirmed: any) => {
        if (confirmed)
          this.settingGroupService
            .deleteSettingGroup(settingGroup.id)
            .then((response) => {
              if (response && response.text) {
                this.alertService.alert_status_success(response.text);
                this.settingGroupService.getSettingGroups({}).then((response_json) => {
                  this.settingGroups = response_json;
                });
              } else {
                this.alertService.alert_status_danger('Error deleting setting group');
              }
            })
            .catch(function () {
              scope.alertService.alert_status_danger('Error deleting setting group');
            });
      })
      .catch((err: any) => {
        console.log('Setting prompt error', err);
      });
  }

  toggleForm() {
    this.addingSettingGroup = !this.addingSettingGroup;
    this.newSettingGroup = new SettingGroup();
  }
}
